module.exports = __webpack_public_path__ + "static/img-principal-matriculacion.6015be6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-principal-matriculacion.jpg
// module id = 565
// module chunks = 243485111170538